import { UISchema } from '@/type';
import { MaterialEditorConfig, TextureSlotSelect } from '../type';

export function getLineMaterialSchema(config: MaterialEditorConfig): UISchema {

  const { dashed } = config as unknown as { dashed: boolean };

  return [
    {
      uiType: 'InputText',
      fieldName: 'type',
      label: '材质类型',
      disabled: true,
    },
    {
      uiType: 'RadioGroup',
      label: '线条类型',
      fieldName: 'dashed',
      values: [
        {
          label: '实线',
          value: false
        },
        {
          label: '虚线',
          value: true
        },
      ],
    },
    {
      uiType: 'ColorPicker',
      fieldName: 'color',
      label: '基础颜色',
      type: ['pure'],
      tooltip: '控制材质的基本颜色，决定物体表面的主色调。',
    },
    {
      uiType: 'InputNumber',
      fieldName: 'linewidth',
      label: '线宽'
    },
    {
      uiType: 'InputNumber',
      fieldName: 'dashSize',
      label: '实线长度',
      disabled: !dashed
    },
    {
      uiType: 'InputNumber',
      fieldName: 'gapSize',
      label: '间隔',
      disabled: !dashed
    },
    {
      uiType: 'InputSlider',
      fieldName: 'dashOffset',
      label: '偏移',
      min: -10,
      max: 10,
      disabled: !dashed
    },
    {
      uiType: 'CheckBox',
      fieldName: 'fog',
      label: '雾效',
    },
  ]
}
        
